/* ═══════════════════════════════════════════════════════
   NŌBLE — noble-wow.js  ·  Couche d'animation "signature"
   Tout est défensif : chaque module ne s'active que si ses
   cibles existent et se désactive proprement en
   reduced-motion / tactile.
   ═══════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var rm   = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var $  = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ── 1. Titre hero révélé mot par mot ─────────────── */
  function splitHeroTitle() {
    var t = $('.cat-hero__title');
    if (!t || rm) return;
    var idx = 0;

    function wrap(el) {
      Array.prototype.slice.call(el.childNodes).forEach(function (n) {
        if (n.nodeType === 3) {                       // nœud texte
          if (!n.textContent.trim()) return;
          var frag = document.createDocumentFragment();
          n.textContent.split(/(\s+)/).forEach(function (part) {
            if (part === '') return;
            if (!part.trim()) { frag.appendChild(document.createTextNode(part)); return; }
            var outer = document.createElement('span');
            outer.className = 'nbl-wm';
            var inner = document.createElement('span');
            inner.className = 'nbl-wm__i';
            inner.textContent = part;
            outer.appendChild(inner);
            outer.setAttribute('data-i', idx++);
            frag.appendChild(outer);
          });
          el.replaceChild(frag, n);
        } else if (n.nodeName === 'EM') {
          wrap(n);                                     // garde l'italique doré
        }
        /* <br> laissé tel quel */
      });
    }
    wrap(t);

    $$('.nbl-wm', t).forEach(function (o) {
      var i = +o.getAttribute('data-i') || 0;
      o.querySelector('.nbl-wm__i').style.transitionDelay = (0.18 + i * 0.085) + 's';
    });

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        $$('.nbl-wm', t).forEach(function (o) { o.classList.add('in'); });
        t.classList.add('nbl-sheen');
      });
    });
  }

  /* ── 2. Inclinaison 3D des cartes au curseur ─────── */
  function tilt(sel, maxDeg, scale, lift) {
    if (!fine || rm) return;
    $$(sel).forEach(function (card) {
      var raf;
      card.addEventListener('mousemove', function (e) {
        var r = card.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width - 0.5;
        var py = (e.clientY - r.top) / r.height - 0.5;
        card.classList.add('nbl-tilting');
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          card.style.transform =
            'perspective(950px) rotateX(' + (-py * maxDeg).toFixed(2) + 'deg)' +
            ' rotateY(' + (px * maxDeg).toFixed(2) + 'deg)' +
            ' translateY(' + lift + 'px) scale(' + scale + ')';
        });
      });
      card.addEventListener('mouseleave', function () {
        if (raf) cancelAnimationFrame(raf);
        card.classList.remove('nbl-tilting');
        card.style.transform = '';
      });
    });
  }

  /* ── 3. Icônes de confiance : tracé au trait ─────── */
  function trustDraw() {
    var band = $('.trust-band');
    if (!band || rm || !('IntersectionObserver' in window)) return;
    var cards = $$('.trust-card', band);

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        cards.forEach(function (c, ci) {
          var svg = c.querySelector('svg');
          if (!svg) return;
          $$('path, rect, circle, line, polyline, polygon', svg).forEach(function (p) {
            var len = 100;
            try { if (p.getTotalLength) { var l = p.getTotalLength(); if (l && isFinite(l)) len = l; } }
            catch (_) {}
            p.style.strokeDasharray = len;
            p.style.strokeDashoffset = len;
            p.style.transition = 'stroke-dashoffset 1.1s cubic-bezier(0.16,1,0.3,1)';
            p.style.transitionDelay = (0.12 + ci * 0.14) + 's';
            requestAnimationFrame(function () {
              requestAnimationFrame(function () { p.style.strokeDashoffset = '0'; });
            });
          });
        });
        io.unobserve(band);
      });
    }, { threshold: 0.3 });
    io.observe(band);
  }

  /* ── 4. Ondulation dorée sur les boutons ─────────── */
  function ripple() {
    if (rm) return;
    $$('.btn--gold').forEach(function (b) {
      b.addEventListener('click', function (e) {
        var r = b.getBoundingClientRect();
        var size = Math.max(r.width, r.height) * 1.1;
        var s = document.createElement('span');
        s.className = 'nbl-ripple';
        s.style.width = s.style.height = size + 'px';
        s.style.left = (e.clientX - r.left - size / 2) + 'px';
        s.style.top  = (e.clientY - r.top  - size / 2) + 'px';
        b.appendChild(s);
        setTimeout(function () { if (s.parentNode) s.parentNode.removeChild(s); }, 700);
      });
    });
  }

  /* ── 5. Repère de scroll sous le hero ────────────── */
  function scrollCue() {
    var hero = $('.cat-hero');
    if (!hero || rm || $('.nbl-cue', hero)) return;
    var cue = document.createElement('div');
    cue.className = 'nbl-cue';
    cue.innerHTML = '<span></span>';
    hero.appendChild(cue);
    window.addEventListener('scroll', function () {
      cue.style.opacity = window.scrollY > 140 ? '0' : '';
    }, { passive: true });
  }

  /* ── 6. Galerie A+ produit : révélation en cascade ─ */
  function aplusReveal() {
    var items = $$('.pw-aplus__item');
    if (!items.length) return;
    if (rm || !('IntersectionObserver' in window)) {
      items.forEach(function (i) { i.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var i = items.indexOf(e.target);
        e.target.style.transitionDelay = ((i % 3) * 0.09).toFixed(2) + 's';
        e.target.classList.add('in');
        io.unobserve(e.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    items.forEach(function (i) { io.observe(i); });
  }

  /* ── Boot ─────────────────────────────────────────── */
  function boot() {
    try {
      splitHeroTitle();
      tilt('.gamme-card', 6.5, 1.015, -6);
      tilt('.testi-card', 4, 1.0, -4);
      tilt('.pw-media__frame', 4.5, 1.0, 0);
      trustDraw();
      aplusReveal();
      ripple();
      scrollCue();
    } catch (err) {
      if (window.console) console.warn('[noble-wow]', err);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

